<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="footer__tabs hidden-xs" v-if="isVisible">
                <ul class="footer__tabs-items">
                    <li v-for="(seoTab, key) in seoTabs" v-on:click="tabSelect(key)" v-bind:class="{ 'active': selectedTab == key }">{{ seoTab.title }}</li>
                </ul>
                <div class="footer__tabs-desc">
                    <span v-for="(seoTab, key) in seoTabs" v-html="seoTab.desc" v-show="selectedTab == key"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="footer__copyright">
        <p>{{ content.meta.copyright }}</p>
        
        <ul class="footer__copyright-links">
            <li v-if="hasPartners"><router-link :to="{ name: 'Textpages', params: { name: 'partner'}}" v-t="'footer.partner'" rel="nofollow"></router-link></li>
            <li><router-link :to="{ name: 'Textpages', params: { name: 'cookie'}}" v-t="'footer.cookie'" rel="nofollow"></router-link></li>
            <li><router-link :to="{ name: 'Textpages', params: { name: 'policy'}}" v-t="'footer.policy'" rel="nofollow"></router-link></li>
            <li><router-link :to="{ name: 'Textpages', params: { name: 'terms'}}" v-t="'footer.terms'" rel="nofollow"></router-link></li>
            <li><router-link :to="{ name: 'Textpages', params: { name: 'contact'}}" v-t="'footer.contact'" rel="nofollow"></router-link></li>
        </ul>
    </div>   
</footer>


// WEBPACK FOOTER //
// ./src/components/layout/footer.tpl.html